import { Box, TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useTranslation } from "../../../hooks/useTranslation";
import { useFiltersWithContext } from "../../../components/dataGridFilter/filter-context/useFiltersWithContext";
import { useEffect, useState } from "react";
import { FiltersButton } from "./DetailedSearch/FiltersButton";

export const OrderListFilterRow = () => {
  const { translate } = useTranslation();

  const { getFilterValue, searchDebounced } = useFiltersWithContext();
  const search = getFilterValue("searchTerm", "eq");
  const [localSearch, setLocalSearch] = useState<string | null>(search);

  useEffect(() => {
    setLocalSearch(search ?? null);
  }, [search]);

  useEffect(() => {
    searchDebounced(localSearch);
  }, [localSearch]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        margin: "8px 0",
        padding: "8px 16px",
        width: "100%",
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      <TextField
        placeholder={translate("common.search")}
        size="small"
        value={localSearch ?? ""}
        onChange={(e) => setLocalSearch(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box flex={1} />

      <FiltersButton />
    </Box>
  );
};
